import React from 'react';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader';

import ListingPageContainer from './components/ListingPage/ListingPageContainer';

import {ExperimentProvider} from '@homeaway/react-experiment';
import {LocalizationContextProvider} from '@homeaway/react-localization-components';

function Root({store, listingPageComponent, siteContext}) {
    const abacus = store.getState().abacusTestsReducer;

    return (
        <Provider store={store}>
            <ExperimentProvider abacus={abacus}>
                <LocalizationContextProvider siteContext={siteContext}>
                    <ListingPageContainer listingPageComponent={listingPageComponent} />
                </LocalizationContextProvider>
            </ExperimentProvider>
        </Provider>
    );
}

export default hot(module)(Root);
